import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { Highcharts } from './../config/highcharts';

const defaultConfig = {
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  title: {
    text: null,
  },
  colorAxis: {
    min: 1,
    type: 'logarithmic',
    stops: [
      [0, '#EFEFFF'],
      [0.5, Highcharts.getOptions().colors[0]],
      [
        1,
        Highcharts.Color(Highcharts.getOptions().colors[0])
          .brighten(-0.5)
          .get(),
      ],
    ],
  },
};

export class CountriesMap extends React.Component {
  static propTypes = {
    countries: PropTypes.array.isRequired,
    countAttribute: PropTypes.string.isRequired,
    dayCount: PropTypes.number.isRequired,
  };

  highchartsCountries = () => {
    const countAttribute = this.props.countAttribute;

    return _.chain(this.props.countries)
      .map(function (country) {
        const count =
          typeof country[countAttribute] === 'function'
            ? country[countAttribute]()
            : country[countAttribute];

        return {
          'hc-key': country.countryCode,
          value: count,
        };
      })
      .filter(function (highchartsCountry) {
        // Guard against zeros, since we're using a logarithmic axis.
        return highchartsCountry.value > 0;
      })
      .value();
  };

  initializeMap = (el) => {
    if (!el) return;

    const config = _.extend({}, defaultConfig, {
      chart: {
        type: 'map',
        renderTo: el,
      },
      series: [
        {
          data: this.highchartsCountries(),
          // The Robinson projection seems like the most reasonable projection, out of the available
          // world maps provided by Highcharts. http://en.wikipedia.org/wiki/Robinson_projection
          mapData: Highcharts.maps['custom/world-robinson'],
          joinBy: 'hc-key',
          name: this.props.dayCount + '-Day Views',
          dataLabels: {
            enabled: false,
          },
        },
      ],
    });

    new Highcharts.Map(config);
  };

  render() {
    if (this.props.countries.length === 0) return null;

    return (
      <div
        className="world-map"
        ref={this.initializeMap}
        key={this.props.countries.length}
      />
    );
  }
}
